export default __webpack_public_path__ + "static/media/category_c1.3b1a9815.svg";